import axiosClient from 'api/axiosClient';
import store from 'app/store';
import AppConfigs from 'general/constants/AppConfigs';
import _ from 'lodash';
import { thunkGetMaintainerList } from './maintainerSlice';
import { AppDialogHelper } from 'general/components/AppDialog';
import ToastHelper from 'general/helpers/ToastHelper';
import AppResource from 'general/constants/AppResource';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import ChangeMaintainerPasswordView from './MaintainerAuth/components/ChangeMaintainerPasswordView';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import MaintainerCreateContractView from './MaintainerContract/components/MaintainerCreateContractView';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import DialogMaintainerReconciliationFeedback from './MaintainerReconciliationReport/components/DialogMaintainerReconciliationFeedback';
import DialogCreateMaintainerReconciliation from './MaintainerReconciliationReport/components/DialogCreateMaintainerReconciliation';
import DialogAddScheduleMaintenanceView from 'features/Charge/ChargePoint/components/DialogAddScheduleMaintenanceView';
import DialogReportErrorPointView from 'features/Charge/ChargePoint/components/DialogReportErrorPointView';

// MARK: ---- CONSTANTS ----
export const MaintainerConstants = {
    // trang thai KTV
    MaintainerStatus: {
        NORMAL: 'NORMAL',
        SIGNED: 'SIGNED',
        SUSPENDED: 'SUSPENDED',
        DELETED: 'DELETED',
        REGISTERED: 'REGISTERED',
    },
    // loai cong viec
    TicketType: {
        MAINTAIN: 'MAINTAIN',   // Bảo trì
        REPAIR: 'REPAIR',       // Sửa chữa
    },
    // loai nguoi tao
    MaintainerCreatedBy: {
        ME: 'ME',               // Tài khoản của bạn
        OTHERS: 'OTHERS',       // Người khác
        SELF: 'SELF',           // Tự đăng ký
    },
    // trang thai cong viec
    TicketStatus: {
        CREATED: 'CREATED',     // Đã tạo
        TODO: 'TODO',           // Chưa thực hiện
        CHECKIN: 'CHECK-IN',    // Đã Check-in
        PENDING: 'PENDING',     // Chờ duyệt
        APPROVAL: 'APPROVAL',   // Đã duyệt
        DONE: 'DONE',           // Hoàn thành
        CANCEL: 'CANCEL',       // Đã hủy
        REJECTED: 'REJECTED',   // Bị từ chối
    },
    // trang thai thanh toan
    PaymentStatus: {
        PENDING: 'PENDING',         // Chưa nghiệm thu
        PROCESSING: 'PROCESSING',   // Chưa thanh toán
        COMPLETED: 'COMPLETED',     // Đã thanh toán
    },
    // loai KTV
    MaintainerType: {
        INDIVIDUAL: 'INDIVIDUAL',     // Cá nhân
        ORGANIZATION: 'ORGANIZATION', // Tổ chức
    },
}

const MaintainerHelper = {
    // MARK: ---- FILTER ----
    Filter: {
        // danh sach KTV
        maintainerList: {
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            operatorId: '',
            status: '',
            type: '',
            from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
            to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
            selectedValue: dateFilter.tatCaThoiGian,
            areaId: '',
            q: '',
            createdBy: '',
            hasSignedContract: '',
            country: '',
        },
        // danh sach tram sac
        chargeStationList: {
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            status: '',
            operatorId: '',
            q: '',
            managedBy: '',
            agencyId: '',
            landlordId: '',
            areaId: '',
            vehicleType: '',
            type: '',
        },
        // danh sach tru sac
        chargePointList: {
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            q: '',
            status: '',
            type: '',
            stationId: '',
            vehicleType: '',
            chargingSpeed: '',
        },
        // danh sach cong viec
        ticketList: {
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            status: '',
            q: '',
            type: '',
            priority: '',
            userId: '',
            stationId: '',
            pointId: '',
            hasFee: '',
            paymentStatus: '',
            locationType: 'WORK-LOCATION',
            latitude: '',
            longitude: '',
            timeFilterType: 'CREATED_DATE',
            selectedValue: dateFilter.tatCaThoiGian,
            from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
            to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
            createdSelectedValue: dateFilter.tatCaThoiGian,
            createdFrom: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
            createdTo: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
        },
        // bao cao doi soat
        reconciliationList: {
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            q: '',
            paymentStatus: '',
            month: moment().subtract(1, 'months').format('YYYY-MM'),
        },
    },
    // MARK: ---- DATA ----
    Data: {
        maintainerTypeOptions: [
            { value: MaintainerConstants.MaintainerType.INDIVIDUAL, name: 'Cá nhân' },
            { value: MaintainerConstants.MaintainerType.ORGANIZATION, name: 'Tổ chức' },
        ],
        maintainerStatusOptions: [
            { value: MaintainerConstants.MaintainerStatus.NORMAL, name: 'Đang hoạt động' },
            { value: MaintainerConstants.MaintainerStatus.SIGNED, name: 'Đã ký hợp đồng' },
            { value: MaintainerConstants.MaintainerStatus.SUSPENDED, name: 'Ngừng hoạt động' },
            { value: MaintainerConstants.MaintainerStatus.DELETED, name: 'Đã xoá' },
            { value: MaintainerConstants.MaintainerStatus.REGISTERED, name: 'Chờ kích hoạt' },
        ],
        maintainerCreatedByOptions: [
            { value: MaintainerConstants.MaintainerCreatedBy.ME, name: 'Tài khoản của bạn' },
            { value: MaintainerConstants.MaintainerCreatedBy.OTHERS, name: 'Người khác' },
            { value: MaintainerConstants.MaintainerCreatedBy.SELF, name: 'Tự đăng ký' },
        ],
        ticketStatusOptions: [
            { value: MaintainerConstants.TicketStatus.CREATED, name: 'Đã tạo' },
            { value: MaintainerConstants.TicketStatus.TODO, name: 'Chưa thực hiện' },
            { value: MaintainerConstants.TicketStatus.CHECKIN, name: 'Đã Check-in' },
            { value: MaintainerConstants.TicketStatus.PENDING, name: 'Chờ duyệt' },
            { value: MaintainerConstants.TicketStatus.APPROVAL, name: 'Đã duyệt' },
            { value: MaintainerConstants.TicketStatus.DONE, name: 'Hoàn thành' },
            { value: MaintainerConstants.TicketStatus.CANCEL, name: 'Đã hủy' },
            { value: MaintainerConstants.TicketStatus.REJECTED, name: 'Bị từ chối' },
        ],
        maintainerTicketStatusOptions: [
            { value: MaintainerConstants.TicketStatus.TODO, name: 'Chưa thực hiện' },
            { value: MaintainerConstants.TicketStatus.CHECKIN, name: 'Đã Check-in' },
            { value: MaintainerConstants.TicketStatus.PENDING, name: 'Chờ duyệt' },
            { value: MaintainerConstants.TicketStatus.APPROVAL, name: 'Đã duyệt' },
            { value: MaintainerConstants.TicketStatus.DONE, name: 'Hoàn thành' },
            { value: MaintainerConstants.TicketStatus.CANCEL, name: 'Đã hủy' },
        ],
        ticketTypeOptions: [
            { value: MaintainerConstants.TicketType.MAINTAIN, name: 'Bảo trì' },
            { value: MaintainerConstants.TicketType.REPAIR, name: 'Sửa chữa' },
        ],
        assignmentModeOptions: [
            { value: 'SELF', name: 'Chuyển vào danh sách công việc tự nhận' },
            { value: 'ASSIGNED', name: 'Chỉ định' },
        ],
        ticketPriorityOptions: [
            { value: 1, name: 'Rất thấp' },
            { value: 2, name: 'Thấp' },
            { value: 3, name: 'Trung bình' },
            { value: 4, name: 'Cao' },
            { value: 5, name: 'Rất cao' },
        ],
        paymentStatusOptions: [
            { value: MaintainerConstants.PaymentStatus.PENDING, name: 'Chưa nghiệm thu' },
            { value: MaintainerConstants.PaymentStatus.PROCESSING, name: 'Chưa thanh toán' },
            { value: MaintainerConstants.PaymentStatus.COMPLETED, name: 'Đã thanh toán' },
        ],
    },
    // MARK: ---- API ----
    API: {
        // MARK: ---- DASHBOARD ----
        // thong ke trang thai cong viec
        requestGetTicketSummary: async (params) => {
            const url = '/maintainer/dashboard/ticketSummary';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, statuses } = response;
                if (result === 'success') {
                    return {
                        // [MaintainerConstants.TicketStatus.CREATED]:
                        //     _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.CREATED
                        //     )?.count || 0,
                        [MaintainerConstants.TicketStatus.TODO]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.TODO)
                                ?.count || 0,
                        [MaintainerConstants.TicketStatus.CHECKIN]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.CHECKIN)
                                ?.count || 0,
                        [MaintainerConstants.TicketStatus.PENDING]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.PENDING
                            )?.count || 0,
                        [MaintainerConstants.TicketStatus.APPROVAL]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.APPROVAL
                            )?.count || 0,
                        [MaintainerConstants.TicketStatus.DONE]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.DONE
                            )?.count || 0,
                        [MaintainerConstants.TicketStatus.CANCEL]:
                            _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.CANCEL
                            )?.count || 0,
                        // [MaintainerConstants.TicketStatus.REJECTED]:
                        //     _.find(statuses, (item) => item.status === MaintainerConstants.TicketStatus.REJECTED
                        //     )?.count || 0,
                    };
                }
                return null;
            } catch (error) {
                return null;
            }
        },
        // thong ke chi so cua KTV
        requestGetMaintainerReport: async (params) => {
            const url = '/maintainer/dashboard/report';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { averageTime, totalIncome, monthlyCompleted } = response;
                return { averageTime, totalIncome, monthlyCompleted };
            } catch (error) {
                return null;
            }
        },
        // thong ke loai yeu cau
        requestGetTicketStatistics: async (params) => {
            const url = '/maintainer/dashboard/ticketStatistics';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, tickets } = response;
                if (result === 'success') {
                    return {
                        [MaintainerConstants.TicketType.MAINTAIN]:
                            _.find(tickets, (item) => item.type === MaintainerConstants.TicketType.MAINTAIN
                            )?.count || 0,
                        [MaintainerConstants.TicketType.REPAIR]:
                            _.find(tickets, (item) => item.type === MaintainerConstants.TicketType.REPAIR)
                                ?.count || 0,
                    };
                }
                return null;
            } catch (error) {
                return null;
            }
        },
        // thong ke cong viec da nhan theo ngay cua KTV
        requestGetDashboardDaily: async (params) => {
            const url = '/maintainer/dashboard/daily';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, daily } = response;
                if (result === 'success') {
                    return daily;
                }
                return null;
            } catch (error) {
                return null;
            }
        },

        // MARK: ---- KY THUAT VIEN ----
        // lay danh sach KTV
        requestGetMaintainerList: async (params) => {
            store.dispatch(thunkGetMaintainerList({ params }));
        },
        // lay chi tiet KTV
        requestGetMaintainerDetail: async (maintainerId) => {
            const url = `/maintainer/${maintainerId}`;
            try {
                const response = await axiosClient.get(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, maintainer } = response;
                if (result === 'success') {
                    return maintainer;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // tao KTV
        requestCreateMaintainer: async (params) => {
            const url = '/maintainer/create';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, maintainer } = response;
                if (result === 'success') {
                    return maintainer;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // cap nhat KTV
        requestUpdateMaintainer: async (maintainerId, params) => {
            const url = `/maintainer/${maintainerId}`;
            try {
                const response = await axiosClient.put(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, maintainerId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // xoa KTV
        requestDeleteMaintainer: async (maintainerId) => {
            const url = `/maintainer/${maintainerId}`;
            try {
                const response = await axiosClient.delete(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // doi mat khau (cua nguoi khac)
        requestResetUserPassword: async (params) => {
            const url = `/maintainer/resetUserPassword`;
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // dat lai mat khau cua KTV
        requestResetMaintainerPassword: async (params) => {
            const url = '/maintainer/resetMaintainerPassword';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // cap nhat thong tin cua chinh KTV
        requestMaintainerUpdateProfile: async (params) => {
            const url = `/maintainer/updateProfile`;
            try {
                const response = await axiosClient.put(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, userId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // MARK: ---- TRAM SAC ----
        // lay danh sach tram sac
        requestGetChargeStationList: async (params) => {
            const url = '/maintainer/cs';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, chargeStations, total } = response;
                if (result === 'success') {
                    return { chargeStations, total };
                }
                return { chargeStations: [], total: 0 };
            } catch (error) {
                return { chargeStations: [], total: 0 };
            }
        },
        // lay chi tiet tram sac
        getChargeStationDetail: async (chargeStationId) => {
            const url = `/maintainer/cs/${chargeStationId}`;
            try {
                const response = await axiosClient.get(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, chargeStation } = response;
                if (result === 'success') {
                    return chargeStation;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },

        // MARK: ---- TRU SAC ----
        // lay danh sach tru sac
        requestGetChargePointList: async (params) => {
            const url = '/maintainer/cp';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, chargePoints, total } = response;
                if (result === 'success') {
                    return { chargePoints, total };
                }
                return { chargePoints: [], total: 0 };
            } catch (error) {
                return { chargePoints: [], total: 0 };
            }
        },
        // lay chi tiet tru sac
        requestGetChargePointDetail: async (chargePointId) => {
            const url = `/maintainer/cp/${chargePointId}`;
            try {
                const response = await axiosClient.get(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, chargePoint } = response;
                if (result === 'success') {
                    return chargePoint;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // MARK: ---- TAI KHOAN NGAN HANG ----
        // lay danh sach tai khoan ngan hang
        requestGetMaintainerBankList: async (params) => {
            const url = `/maintainer/bankAccount/all`;
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, bankAccounts } = response;
                if (result === 'success') {
                    return bankAccounts;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // tao tai khoan ngan hang
        requestCreateMaintainerBank: async (params) => {
            const url = '/maintainer/bankAccount/create';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, bankAccount } = response;
                if (result === 'success') {
                    return bankAccount;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // cap nhat tai khoan ngan hang
        requestUpdateMaintainerBank: async (bankAccountId, params) => {
            const url = `/maintainer/bankAccount/${bankAccountId}`;
            try {
                const response = await axiosClient.put(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, bankAccountId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // xoa tai khoan ngan hang
        requestDeleteMaintainerBank: async (bankAccountId) => {
            const url = `/maintainer/bankAccount/${bankAccountId}`;
            try {
                const response = await axiosClient.delete(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // MARK: ---- HOP DONG KTV ----
        // lay ds hop dong cua KTV
        requestGetMaintainerContractList: async (params) => {
            const url = '/maintainer/contract/all';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contracts, total } = response;
                if (result === 'success') {
                    return { contracts, total };
                }
                return { contracts: [], total: 0 };
            } catch (error) {
                return { contracts: [], total: 0 };
            }
        },
        // sinh so hop dong
        requestGenerateContractNumber: async (params) => {
            const url = '/maintainer/contract/generateContractNumber';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contractNumber } = response;
                if (result === 'success') {
                    return contractNumber;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // tao hop dong KTV
        requestCreateMaintainerContract: async (params) => {
            const url = '/maintainer/contract/createMaintainerContract';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contract } = response;
                if (result === 'success') {
                    return contract;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // admin ky hop dong
        requestAdminSignContract: async (contractId) => {
            const url = `/maintainer/contract/adminSignContract/${contractId}`;
            try {
                const response = await axiosClient.post(url, {}, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contract } = response;
                if (result === 'success') {
                    return contract;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // KTV ky hop dong
        requestMaintainerSignContract: async (contractId, hsmAgreementUUID, hsmPassword) => {
            const url = `/maintainer/contract/agencySignContract/${contractId}`;
            try {
                const response = await axiosClient.post(url, { hsmAgreementUUID, hsmPassword }, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contract } = response;
                if (result === 'success') {
                    return contract;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // cap nhat hop dong
        requestUpdateContract: async (contractId, params) => {
            const url = `/maintainer/contract/updateContract/${contractId}`;
            try {
                const response = await axiosClient.put(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, contract } = response;
                if (result === 'success') {
                    return contract;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // xoa hop dong
        requestDeleteContract: async (contractId) => {
            const url = `/maintainer/contract/deleteContract/${contractId}`;
            try {
                const response = await axiosClient.delete(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // MARK: ---- CONG VIEC BAO TRI ----
        // lay danh sach cong viec
        requestGetTicketList: async (params) => {
            const url = `/ticket`;
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, tickets, total } = response;
                if (result === 'success') {
                    return { tickets, total };
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // lay chi tiet cong viec
        requestGetTicketDetail: async (ticketId) => {
            const url = `/ticket/${ticketId}`;
            try {
                const response = await axiosClient.get(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticket } = response;
                if (result === 'success') {
                    return ticket;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // tao cong viec
        requestCreateTicket: async (params) => {
            const url = '/ticket/create';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticket } = response;
                if (result === 'success') {
                    return ticket;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // cap nhat cong viec
        requestUpdateTicket: async (ticketId, params) => {
            const url = `/ticket/${ticketId}`;
            try {
                const response = await axiosClient.put(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // xoa cong viec
        requestDeleteTicket: async (ticketId) => {
            const url = `/ticket/${ticketId}`;
            try {
                const response = await axiosClient.delete(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || false;
            }
        },
        // phan cong cong viec
        requestAssignTicket: async (params) => {
            const url = '/ticket/assignTicket';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // lay danh sach cong viec cua toi
        requestGetMyTicket: async (params) => {
            const url = `/ticket/my`;
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, tickets, total } = response;
                if (result === 'success') {
                    return { tickets, total };
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // KTV tu choi cong viec
        requestRejectTicket: async (params) => {
            const url = '/ticket/rejectTicket';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // KTV checkin tại chỗ
        requestCheckinTicket: async (params) => {
            const url = '/ticket/checkinTicket';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data || null;
            }
        },
        // KTV bao hoan thanh cong viec
        requestCompleteTicket: async (params) => {
            const url = '/ticket/completeTicket';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketId } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // lay lich su phan cong cong viec
        requestGetTicketHistoryList: async (params) => {
            const url = `/ticketHistory`;
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result, ticketHistories, total } = response;
                if (result === 'success') {
                    return { ticketHistories, total };
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // thiet lap lich bao tri dinh ky
        requestCreateMaintenanceSchedule: async (params) => {
            const url = '/ticket/createMaintenanceSchedule';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1`
                });
                const { result } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // MARK: ---- ĐỐI SOÁT ----
        // lay ds doi soat
        requestGetReconciliationList: async (params) => {
            const url = '/reconciliation/list';
            try {
                const response = await axiosClient.get(url, {
                    params,
                    baseURL: `${AppConfigs.env.baseUrl}api/v1/maintainer`
                });
                const { result, reconciliations, total, totalAmount } = response;
                if (result === 'success') {
                    return { reconciliations, total, totalAmount };
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // lay chi tiet doi soat
        requestGetReconciliationDetail: async (reconciliationId) => {
            const url = `/reconciliation/detail?reconciliationId=${reconciliationId}`;
            try {
                const response = await axiosClient.get(url, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1/maintainer`
                });
                const { result, reconciliation } = response;
                if (result === 'success') {
                    return reconciliation;
                }
                return null;
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // tao doi soat KTV
        requestCreateMaintainerReconciliation: async (params) => {
            const url = '/reconciliation/create';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1/maintainer`
                });
                const { result, reconciliations } = response;
                return result === 'success';
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
        // gui phan hoi doi soat
        requestCreateFeedbackReconciliation: async (params) => {
            const url = '/reconciliation/feedback';
            try {
                const response = await axiosClient.post(url, params, {
                    baseURL: `${AppConfigs.env.baseUrl}api/v1/maintainer`
                });
                const { result } = response;
                return result === 'success'
            } catch (error) {
                return error?.response?.data?.reason || null;
            }
        },
    },
    // MARK: ---- UTILS ----
    Utils: {
        // lay mau trang thai KTV
        getMaintainerStatusColor: (status) => {
            switch (status) {
                case MaintainerConstants.MaintainerStatus.NORMAL:
                    return 'success';
                case MaintainerConstants.MaintainerStatus.SIGNED:
                    return 'info';
                case MaintainerConstants.MaintainerStatus.SUSPENDED:
                    return 'gray';
                case MaintainerConstants.MaintainerStatus.DELETED:
                    return 'danger';
                case MaintainerConstants.MaintainerStatus.REGISTERED:
                    return 'info';
                default:
                    return 'warning';
            }
        },
        // lay ten do uu tien cong viec
        getTicketPriorityName: (priority) => {
            switch (priority) {
                case 1:
                    return 'Rất thấp';
                case 2:
                    return 'Thấp';
                case 3:
                    return 'Trung bình';
                case 4:
                    return 'Cao';
                case 5:
                    return 'Rất cao';
                default:
                    return '';
            }
        },
        // lay mau do uu tien cong viec
        getTicketPriorityColor: (priority) => {
            switch (priority) {
                case 1:
                    return 'secondary';
                case 2:
                    return 'warning';
                case 3:
                    return 'primary';
                case 4:
                    return 'danger';
                case 5:
                    return 'info';
                default:
                    return '';
            }
        },
        // lay ten trang thai cong viec
        getTicketStatusName: (status) => {
            switch (status) {
                case MaintainerConstants.TicketStatus.CREATED:
                    return 'Đã tạo';
                case MaintainerConstants.TicketStatus.TODO:
                    return 'Chưa thực hiện';
                case MaintainerConstants.TicketStatus.CHECKIN:
                    return 'Đã Check-in';
                case MaintainerConstants.TicketStatus.PENDING:
                    return 'Chờ duyệt';
                case MaintainerConstants.TicketStatus.APPROVAL:
                    return 'Đã duyệt';
                case MaintainerConstants.TicketStatus.DONE:
                    return 'Hoàn thành';
                case MaintainerConstants.TicketStatus.CANCEL:
                    return 'Đã hủy';
                case MaintainerConstants.TicketStatus.REJECTED:
                    return 'Bị từ chối';
                default:
                    return '';
            }
        },
        // lay mau trang thai cong viec
        getTicketStatusColor: (status) => {
            switch (status) {
                case MaintainerConstants.TicketStatus.CREATED:
                    return 'secondary';
                case MaintainerConstants.TicketStatus.TODO:
                    return 'secondary';
                case MaintainerConstants.TicketStatus.CHECKIN:
                    return 'primary';
                case MaintainerConstants.TicketStatus.PENDING:
                    return 'warning';
                case MaintainerConstants.TicketStatus.APPROVAL:
                    return 'info';
                case MaintainerConstants.TicketStatus.DONE:
                    return 'success';
                case MaintainerConstants.TicketStatus.CANCEL:
                    return 'danger';
                case MaintainerConstants.TicketStatus.REJECTED:
                    return 'danger';
                default:
                    return '';
            }
        },
        // lay ten trang thai thanh toan
        getPaymentStatusName: (status) => {
            switch (status) {
                case MaintainerConstants.PaymentStatus.PENDING:
                    return 'Chưa nghiệm thu';
                case MaintainerConstants.PaymentStatus.PROCESSING:
                    return 'Chưa thanh toán';
                case MaintainerConstants.PaymentStatus.COMPLETED:
                    return 'Đã thanh toán';
                default:
                    return '';
            }
        },
        // lay mau trang thai thanh toan
        getPaymentStatusColor: (status) => {
            switch (status) {
                case MaintainerConstants.PaymentStatus.PENDING:
                    return 'secondary';
                case MaintainerConstants.PaymentStatus.PROCESSING:
                    return 'warning';
                case MaintainerConstants.PaymentStatus.COMPLETED:
                    return 'success';
                default:
                    return '';
            }
        },
        // ten trang thai thanh toan doi soat
        getReconciliationPaymentStatusName: (totalTicket, receivedTicket) => {
            const isPaid = Number(totalTicket === receivedTicket);
            switch (isPaid) {
                case 1:
                    return 'Đã thanh toán';
                case 0:
                    return `Chưa thanh toán (${totalTicket - receivedTicket}/${totalTicket})`;
                default:
                    return '';
            }
        },
        // mau sac trang thai thanh toan doi soat
        getReconciliationPaymentStatusColor: (totalTicket, receivedTicket) => {
            const isPaid = Number(totalTicket === receivedTicket);
            switch (isPaid) {
                case 1:
                    return 'success';
                case 0:
                    return 'primary';
                default:
                    return '';
            }
        },
    },
    // MARK: ---- UI ----
    UI: {
        // dung hoat dong
        showDialogConfirmStopMaintainer: (row, onCompleted = () => { }) => {
            AppDialogHelper.show(
                'Ngừng hoạt động',
                `Bạn có chắc muốn ngừng hoạt động KTV <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                        },
                    },
                    {
                        title: 'Ngừng hoạt động',
                        type: 'negative',
                        onClick: async () => {
                            AppDialogHelper.hide();
                            const res = await MaintainerHelper.API.requestUpdateMaintainer(row?.agencyId, {
                                status: 'SUSPENDED',
                            });
                            if (res && _.isBoolean(res)) {
                                ToastHelper.showSuccess(`Ngừng hoạt động KTV thành công`);
                                onCompleted();
                            } else {
                                ToastHelper.showError(res || `Ngừng hoạt động KTV thất bại`);
                            }
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogStopAgency
            );
        },
        // khoi phuc hoạt dong
        showDialogConfirmActiveMaintainer: (row, onCompleted = () => { }) => {
            AppDialogHelper.show(
                'Khôi phục hoạt động',
                `Bạn có chắc muốn khôi phục hoạt động KTV <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                        },
                    },
                    {
                        title: 'Khôi phục',
                        type: 'success',
                        onClick: async () => {
                            AppDialogHelper.hide();
                            const res = await MaintainerHelper.API.requestUpdateMaintainer(row?.agencyId, {
                                status: 'NORMAL',
                            });
                            if (res && _.isBoolean(res)) {
                                ToastHelper.showSuccess(`Khôi phục KTV thành công`);
                                onCompleted();
                            } else {
                                ToastHelper.showError(res || `Khôi phục KTV thất bại`);
                            }
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogActiveAgency
            );
        },
        // xoa KTV
        showDialogConfirmDeleteMaintainer: (row, onCompleted = () => { }) => {
            AppDialogHelper.show(
                `Xoá KTV`,
                `Bạn thực sự muốn xoá KTV <span class="font-weight-boldest text-gray-800">${row?.name}</span>?`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                        },
                    },
                    {
                        title: 'Xóa',
                        type: 'negative',
                        onClick: async () => {
                            AppDialogHelper.hide();
                            const res = await MaintainerHelper.API.requestDeleteMaintainer(row?.agencyId);
                            if (res && _.isBoolean(res)) {
                                ToastHelper.showSuccess(`Xoá KTV thành công`);
                                onCompleted();
                            } else {
                                ToastHelper.showError(res || `Xóa KTV thất bại`);
                            }
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogDeleteVehicle
            );
        },
        // kich hoat KTV
        showDialogConfirmAcceptMaintainer: (row, onCompleted = () => { }) => {
            AppDialogHelper.show(
                `Kích hoạt tài khoản`,
                `Bạn có chắc muốn kích hoạt tài khoản KTV <span class="font-weight-boldest text-gray-800">${row?.name}</span> không?`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                        },
                    },
                    {
                        title: 'Kích hoạt',
                        type: 'success',
                        onClick: async () => {
                            AppDialogHelper.hide();
                            const isSuccess = await MaintainerHelper.API.requestUpdateMaintainer(row?.agencyId, {
                                status: MaintainerConstants.MaintainerStatus.NORMAL,
                            });
                            if (isSuccess) {
                                ToastHelper.showSuccess(`Kích hoạt tài khoản KTV thành công`);
                                onCompleted();
                            } else {
                                ToastHelper.showError(`Kích hoạt tài khoản KTV thất bại`);
                            }
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogAcceptAgency
            );
        },
        // hien dialog xac nhan tao hop dong voi MAINTAINER de bao tri, sua chua
        showDialogConfirmCreateContractWithMaintainer: (maintainer, onDone, contract, onCheck) => {
            console.log({ maintainer, contract });
            AppCustomDialogHelper.show(
                '',
                <MaintainerCreateContractView
                    maintainer={maintainer}
                    contract={contract}
                    title={!Utils.isValid(contract) ? 'Tạo hợp đồng KTV' : 'Cập nhật hợp đồng KTV'}
                    contentEl={
                        !Utils.isValid(contract) ? (
                            <>
                                Bạn muốn tạo hợp đồng kỹ thuật viên cho người dùng {' '}
                                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                    {maintainer?.name}
                                </span>
                                ?
                            </>
                        ) : null
                    }
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async (param) => {
                        if (
                            param?.contractType === AgencyConstants.ContractType.DIGITAL &&
                            !maintainer?.hsmAgreementUUID
                        ) {
                            ToastHelper.showError(`KTV chưa có chữ ký số`);
                        } else {
                            if (onCheck) {
                                await onCheck();
                            }
                            let paramCreateContract = {
                                agencyId: maintainer?.agencyId,
                                operatorId: maintainer?.operatorId,
                                ...param,
                            };
                            let result = null;
                            if (Utils.isValid(contract)) {
                                result = await MaintainerHelper.API.requestUpdateContract(
                                    contract?.contractId,
                                    paramCreateContract
                                );
                            } else {
                                result = await MaintainerHelper.API.requestCreateMaintainerContract(paramCreateContract);
                            }
                            AppCustomDialogHelper.hide();
                            if (result && _.isObject(result)) {
                                ToastHelper.showSuccess(
                                    !Utils.isValid(contract)
                                        ? 'Tạo hợp đồng thành công'
                                        : 'Cập nhật hợp đồng thành công'
                                );
                                if (onDone) {
                                    onDone();
                                }
                            } else {
                                ToastHelper.showError(result);
                            }
                        }
                    }}
                />,
                'md',
                false,
                true
            );
        },
        showDialogConfirmChangeMaintainerPassword: (maintainer, onDone) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    title="Đặt lại mật khẩu"
                    contentEl={<>Thay đổi mật khẩu đăng nhập cho tài khoản KTV</>}
                    iconEl={<img src={AppResource.images.dialogIcons.dialogChangePassword} />}
                    bodyEl={
                        <ChangeMaintainerPasswordView
                            maintainer={maintainer}
                            onCancel={() => {
                                AppCustomDialogHelper.hide();
                            }}
                            onDone={() => {
                                AppCustomDialogHelper.hide();
                                if (onDone) {
                                    onDone();
                                }
                            }}
                        />
                    }
                    removeFooter={true}
                />,
                'md',
                false,
                true
            );
        },
        // xoa cong viec
        showDialogConfirmDeleteTicket: (row, onCompleted = () => { }) => {
            AppDialogHelper.show(
                `Xoá công việc`,
                `Bạn thực sự muốn xoá công việc <span class="font-weight-boldest text-gray-800">${row?.ticketCode}</span>?`,
                [
                    {
                        title: 'Hủy bỏ',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                        },
                    },
                    {
                        title: 'Xóa',
                        type: 'negative',
                        onClick: async () => {
                            AppDialogHelper.hide();
                            const res = await MaintainerHelper.API.requestDeleteTicket(row?.ticketId);
                            if (res && _.isBoolean(res)) {
                                ToastHelper.showSuccess(`Xoá công việc thành công`);
                                onCompleted();
                            } else {
                                ToastHelper.showError(res || `Xóa công việc thất bại`);
                            }
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogDeleteVehicle
            );
        },
        // huy cong viec
        showDialogConfirmCancelTicket: (row, onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
                    title="Hủy công việc"
                    contentEl="Nhập lý do để tiến hành hoàn tất thao tác hủy."
                    inputLabel={['Lý do']}
                    showInput={true}
                    isFormTextArea={true}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async (values) => {
                        const [cancelingReason] = values;
                        AppCustomDialogHelper.hide();
                        const result = await MaintainerHelper.API.requestUpdateTicket(row?.ticketId, {
                            status: MaintainerConstants.TicketStatus.CANCEL,
                            cancelReason: cancelingReason,
                        });
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Hủy công việc thành công');
                            onCompleted();
                        } else {
                            ToastHelper.showError(result || 'Hủy công việc thất bại');
                        }
                    }}
                    confirmButtonRed={true}
                    confirmButtonText="Hủy"
                />,
                'md',
                false,
                true
            );
        },
        // duyet cong viec
        showDialogConfirmApprovalTicket: (row, onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
                    title="Duyệt công việc"
                    contentEl="Bạn có chắc muốn duyệt công việc này không?"
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async () => {
                        AppCustomDialogHelper.hide();
                        const result = await MaintainerHelper.API.requestUpdateTicket(row?.ticketId, {
                            status: MaintainerConstants.TicketStatus.APPROVAL,
                        });
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Duyệt công việc thành công');
                            onCompleted();
                        } else {
                            ToastHelper.showError(result || 'Duyệt công việc thất bại');
                        }
                    }}
                />,
                'md',
                false,
                true
            );
        },
        // KTV nhan viec
        showDialogConfirmMaintainerAssignTicket: (row, onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogAssignTicket} />}
                    title="Nhận việc"
                    contentEl={(
                        <>
                            Bạn có xác nhận tiến hành nhận công việc {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {row?.ticketCode}
                            </span>
                            {' '} này không?
                        </>
                    )}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async () => {
                        AppCustomDialogHelper.hide();
                        const result = await MaintainerHelper.API.requestAssignTicket({ ticketId: row?.ticketId });
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Nhận việc thành công');
                            onCompleted();
                        } else {
                            ToastHelper.showError(result || 'Nhận việc thất bại');
                        }
                    }}
                    confirmButtonText="Nhận việc"
                />,
                'md',
                false,
                true
            );
        },
        // tu choi cong viec
        showDialogConfirmRejectTicket: (row, onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
                    title="Từ chối công việc"
                    contentEl="Nhập lý do để tiến hành hoàn tất thao tác từ chối công việc."
                    inputLabel={['Lý do']}
                    showInput={true}
                    isFormTextArea={true}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async (values) => {
                        const [cancelingReason] = values;
                        AppCustomDialogHelper.hide();
                        const result = await MaintainerHelper.API.requestRejectTicket({
                            ticketId: row?.ticketId,
                            cancelReason: cancelingReason,
                        });
                        if (result && _.isBoolean(result)) {
                            ToastHelper.showSuccess('Từ chối công việc thành công');
                            onCompleted();
                        } else {
                            ToastHelper.showError(result || 'Từ chối công việc thất bại');
                        }
                    }}
                    confirmButtonRed={true}
                    confirmButtonText="Từ chối"
                />,
                'md',
                false,
                true
            );
        },
        // KTV chua bat chia se vi tri
        showDialogNoticeLocationNotShared: () => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
                    title="Chưa bật chia sẻ vị trí"
                    contentEl="Hệ thống không thể xác định vị trí của bạn. Vui lòng bật chia sẻ vị trí trên thiết bị để tiếp tục thực hiện check-in và bắt đầu công việc."
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={() => {
                        AppCustomDialogHelper.hide();

                        if (!navigator.geolocation) {
                            alert('Trình duyệt không hỗ trợ chia sẻ vị trí.');
                            return;
                        }

                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                console.log('Vị trí được chia sẻ thành công');
                            },
                            (error) => {
                                if (error.code === error.PERMISSION_DENIED) {
                                    alert(
                                        'Bạn đã chặn chia sẻ vị trí vĩnh viễn.\n\n' +
                                        'Vui lòng vào cài đặt trình duyệt để bật lại:\n' +
                                        '- Chrome/Edge: Click biểu tượng khóa bên trái thanh địa chỉ → Cài đặt trang web → Vị trí → Cho phép\n' +
                                        '- Firefox: Nhập about:preferences#privacy → Permissions → Location → Settings\n' +
                                        '- Safari: Cài đặt → Safari → Cài đặt cho các trang web → Vị trí → Cho phép'
                                    );
                                } else {
                                    alert('Không thể lấy vị trí: ' + error.message);
                                }
                            },
                            {
                                enableHighAccuracy: true,
                                timeout: 15000,
                                maximumAge: 0
                            }
                        );
                    }}
                    confirmButtonRed={true}
                    confirmButtonText='Bật chia sẻ vị trí'
                />,
                'md',
                false,
                true
            );
        },
        // KTV checkin qua xa
        showDialogNoticeCheckinTooFar: (validDistance, onReload = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogCheckinFailed} />}
                    title="Check-in thất bại"
                    contentEl={(
                        <>
                            Hệ thống phát hiện vị trí hiện tại của bạn quá xa so với trạm sạc. Vui lòng di chuyển đến khu vực trạm sạc để tiếp tục thực hiện check-in và bắt đầu công việc. {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                Phạm vi hợp lệ: {Utils.formatNumber(validDistance)} m.
                            </span>
                        </>
                    )}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    onConfirm={async () => {
                        AppCustomDialogHelper.hide();
                        onReload();
                    }}
                    confirmButtonRed={true}
                    confirmButtonText='Thử lại'
                />,
                'md',
                false,
                true
            );
        },
        // KTV checkin qua som
        showDialogNoticeCheckinTooEarly: (validTime) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
                    title="Không thể check-in"
                    contentEl={(
                        <>
                            Bạn không thể check-in tại thời điểm quá sớm so với thời hạn cần đến xử lý (thời gian cho phép: {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                trước {Utils.formatNumber(validTime)} phút
                            </span>
                            {' '} ).
                        </>
                    )}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        },
        // KTV checkin qua muon
        showDialogNoticeCheckinTooLate: (validTime) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
                    title="Đã quá giờ đến check-in"
                    contentEl={(
                        <>
                            Đã quá giờ để có mặt tại địa điểm check-in công việc. Nếu đến trễ hạn quá {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {Utils.formatNumber(validTime)} phút
                            </span>
                            {' '} công việc có thể bị hủy.
                        </>
                    )}
                    onCancel={() => {
                        AppCustomDialogHelper.hide();
                    }}
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        },
        // KTV checkin thanh cong
        showDialogNoticeCheckinSuccess: (onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogCheckinSuccess} />}
                    title="Check-in thành công"
                    contentEl="Bạn đã check-in thành công. Hãy bắt đầu tiến hành công việc tại trạm sạc theo quy trình được giao."
                    onCancel={() => {
                        onCompleted();
                        AppCustomDialogHelper.hide();
                    }}
                    cancelButtonText='Tôi đã hiểu'
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        },
        // KTV cap nhat ticket thanh cong
        showDialogNoticeUpdateTicketSuccess: (onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogUpdateTicketSuccess} />}
                    title="Gửi cập nhật thành công"
                    contentEl="Nội dung cập nhật đã được gửi cho nhà điều hành. Trong thời gian chờ phê duyệt, hãy tiếp tục tiến hành công việc tại trạm sạc theo quy trình được giao."
                    onCancel={() => {
                        onCompleted();
                        AppCustomDialogHelper.hide();
                    }}
                    cancelButtonText='Tôi đã hiểu'
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        },
        // KTV hoan thanh ticket thanh cong
        showDialogNoticeCompleteTicketSuccess: (row, onCompleted = () => { }) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogCompleteTicketSuccess} />}
                    title="Hoàn thành"
                    contentEl={(
                        <>
                            Hệ thống đã ghi nhận trạng thái hoàn thành và tạo hóa đơn cho công việc  {' '}
                            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                                {row?.ticketCode}.
                            </span>
                        </>
                    )}
                    onCancel={() => {
                        onCompleted();
                        AppCustomDialogHelper.hide();
                    }}
                    cancelButtonText='Tôi đã hiểu'
                    isShowConfirmButton={false}
                />,
                'md',
                false,
                true
            );
        },
        // hien dialog phan hoi doi soat
        showDialogReconciliationFeedback: (reconciliation, adminRole, onDone) => {
            AppCustomDialogHelper.show(
                '',
                <AgencySaleDialogView
                    iconEl={<img src={AppResource.images.dialogIcons.dialogFeedback} />}
                    title={adminRole ? "Xem phản hồi" : "Gửi phản hồi"}
                    contentEl={
                        adminRole ?
                            <>
                                Xem phản hồi từ đối tác
                            </>
                            : <>
                                Vui lòng nhập lý do gửi phản hồi cho nhà điều hành.
                            </>
                    }
                    bodyEl={
                        <DialogMaintainerReconciliationFeedback
                            reconciliation={reconciliation}
                            adminRole={adminRole}
                            onCancel={() => {
                                AppCustomDialogHelper.hide();
                            }}
                            onDone={() => {
                                AppCustomDialogHelper.hide();
                                if (onDone) {
                                    onDone();
                                }
                            }}
                        />
                    }
                    removeFooter={true}
                />,
                'md',
                false,
                true
            );
        },
        // hien dialog tao lai doi soat
        showDialogCreateReconciliation: (reconciliation, onDone) => {
            AppCustomDialogHelper.show(
                'Tạo lại đối soát',
                <DialogCreateMaintainerReconciliation
                    item={reconciliation}
                    onCancel={() => AppCustomDialogHelper.hide()}
                    onDone={() => {
                        onDone();
                        AppCustomDialogHelper.hide();
                    }}
                />,
                'md',
                false,
                true
            );
        },
        // hien dialog thiet lap lich bao tri dinh ky
        showDialogCreateMaintenanceSchedule: (item, onDone) => {
            AppCustomDialogHelper.show(
                'Thiết lập lịch bảo trì định kỳ',
                <DialogAddScheduleMaintenanceView
                    item={item}
                    onCancel={() => AppCustomDialogHelper.hide()}
                    onDone={() => {
                        onDone();
                        AppCustomDialogHelper.hide();
                    }}
                />,
                'lg',
                false,
                true
            );
        },
        // agency bao loi tru sac
        showDialogReportErrorPoint: (item, onDone) => {
            AppCustomDialogHelper.show(
                'Báo lỗi trụ sạc',
                <DialogReportErrorPointView
                    item={item}
                    onCancel={() => AppCustomDialogHelper.hide()}
                    onDone={() => {
                        onDone();
                        AppCustomDialogHelper.hide();
                    }}
                />,
                'lg',
                false,
                true
            );
        },
    },
}

export default MaintainerHelper;